import { Howl, Howler } from 'howler';

export const soundMix = {
  data() {
    return {
      audio_context: '',
      oscillator: '',
      s_start: '',
      speech: ''
    }
  },
  watch: {
   'params.sounds': 'initSpeech'
  },
  props: {},
  methods: {
    /** Получаем команду на звук */
    playMentalSound(cif) {
      console.log('play mental sound');
      if (this.params.users === 1) {
        if (this.params.sounds === 'sound') {
          console.log('start play');
          this.start_play('cif');
        } else if (this.params.sounds === 'speech' && cif) {
          this.checkCifSpeech(cif);
        }
      }
    },
    playBeeSound(sound){
      if (this.params.users === 1) {
        if (this.params.sounds) {
          this.start_play(sound);
        }
      }
    },
    /** Определяем цифру и отправляем на спич */
    checkCifSpeech(cif) {
      this.playChain(this.breakNumber(cif));
    },
    /** Разбиваем число на спрайты */
    breakNumber(num) {
      let arr = [];
      if (num < 0) arr.push('minus');

      let f_num = Math.abs(num);

      function f100(f_num) {
        if (f_num < 20) {
          // console.log('Меньше 20, добавляю целиком');
          arr.push(f_num.toString());
        } else {
          // console.log('Больше 20, дроблю');
          let num = f_num.toString().split('');
          arr.push((num[0] * 10).toString());
          arr.push(num[1].toString());
        }
      }

      if (f_num < 100) {
        f100(f_num);
      }

      if (f_num > 100 && f_num < 1000) {
        let num = f_num.toString().split('');
        let num2 = (num[1] + num[2]) * 1;
        arr.push((num[0] * 100).toString());
        f100(num2);
      }

      //arr.push(Math.abs(num).toString());
      console.log(arr);
      //this.playChain(arr);
      return arr;
    },
    /** Проигрываем несколько спрайтов */
    playChain(arr) {
      let n = arr.length;
      let i = 0;
      // console.log('Play Chain', arr, n, i);
      let speech = this.speech;

      async function chain(str) {
        speech.play(str.toString());
        let promise = new Promise((resolve, reject) => {
          i++;
          speech.on('end', function () {
            return resolve();
          });
        });

        let result = await promise;
        // console.log('Результат промиса выполнился', str);
        if (i !== n) {
          chain(arr[i]);
        }
      }

      chain(arr[i]);

    },

    /** Проигрываем На старт */
    start_play(part = 'cif2') {      
      if (this.params.sounds) {
        // было еще условие -> this.params.users === 1
        this.s_start.play(part);
      }
    },

    /** Инициализация звуков */
    initSamples() {
      let start = new Howl({
        src: ['storage/app/media/sounds/start2.mp3'],
        sprite: {
          3: [30, 640],
          2: [1030, 790],
          1: [2030, 500],
          cif: [2710, 995]
        }
      });
      this.s_start = start;
    },
    /** Звуки Жоры */
    initBeeSamples() {
      let start = new Howl(
        {
          src: ["storage/app/media/sounds/sprite2.mp3"],
          sprite: {
            cif1: [0, 1645.7142857142858],
            cif2: [3000, 2037.551020408163],
            no: [7000, 783.6734693877547],
            yes1: [9000, 3030.204081632654],
            yes2: [14000, 3030.204081632654]
          }
        });
      this.s_start = start;
    },
    /** Инициализация речи */
    initSpeech() {
      let speech = new Howl({
        src: ['storage/app/media/sounds/cifers3.mp3'],
        rate: 1,
        sprite: {
          "1": [
            0,
            357.68707482993193
          ],
          "2": [
            24000,
            333.1065759637184
          ],
          "3": [
            30000,
            363.76417233559977
          ],
          "4": [
            36000,
            528.9569160997729
          ],
          "5": [
            42000,
            527.9818594104313
          ],
          "6": [
            48000,
            412.8571428571419
          ],
          "7": [
            54000,
            322.2448979591803
          ],
          "8": [
            60000,
            489.8412698412713
          ],
          "9": [
            66000,
            417.0521541950052
          ],
          "10": [
            2000,
            493.5827664399093
          ],
          "11": [
            6000,
            690.7256235827664
          ],
          "12": [
            8000,
            550.2040816326535
          ],
          "13": [
            10000,
            574.1496598639451
          ],
          "14": [
            12000,
            695.7369614512477
          ],
          "15": [
            14000,
            738.231292517007
          ],
          "16": [
            16000,
            571.1564625850336
          ],
          "17": [
            18000,
            559.750566893424
          ],
          "18": [
            20000,
            636.8253968253974
          ],
          "19": [
            22000,
            620.7709750566898
          ],
          "20": [
            26000,
            485.85034013605366
          ],
          "30": [
            32000,
            408.52607709750544
          ],
          "40": [
            38000,
            387.7097505668914
          ],
          "50": [
            44000,
            597.7777777777789
          ],
          "60": [
            50000,
            509.7052154195012
          ],
          "70": [
            56000,
            425.7823129251719
          ],
          "80": [
            62000,
            530.0000000000011
          ],
          "90": [
            68000,
            513.2879818594063
          ],
          "100": [
            4000,
            375.53287981859376
          ],
          "200": [
            28000,
            506.9387755102035
          ],
          "300": [
            34000,
            446.73469387755205
          ],
          "400": [
            40000,
            567.7097505668911
          ],
          "500": [
            46000,
            445.21541950113175
          ],
          "600": [
            52000,
            445.6916099773238
          ],
          "700": [
            58000,
            554.8752834467123
          ],
          "800": [
            64000,
            602.5396825396854
          ],
          "900": [
            70000,
            505.5328798185883
          ],
          "minus": [
            72000,
            401.8820861678023
          ]
        }
      });
      this.speech = speech;
    }
  },
  mounted() {
    if(this.sound && this.sound === 'mental'){
      this.initSamples();
    } else {
      this.initBeeSamples();
    }
  }
};